import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { homeAddressFor } from './utils/homeAddress';

// opened at the Firebase address: the app is at yelodubai.com now (utils/homeAddress)
const home = homeAddressFor(window.location);
if (home) window.location.replace(home);

// Firestore write tracker: a diagnostic for development only - never in the live site
if (process.env.NODE_ENV === 'development') {
  import('./utils/writeTracker');
}

// moving to yelodubai.com: nothing is drawn or read here first
if (!home) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}


reportWebVitals();
